module.exports = __webpack_public_path__ + "img/register.a84d738b.png";